import { useQuery } from '@tanstack/react-query';

import { getDocumentTypes } from '../api/document-type.api';

export const useDocumentTypesInit = () => {
	const {
		data: documentTypes,
		error,
		isPending,
	} = useQuery({
		queryKey: ['GET_PROJECT_DOCUMENT_TYPES'],
		queryFn: () => getDocumentTypes(),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		enabled: true,
	});

	return {
		documentTypes,
		isPending,
		error,
	};
};
